import { writable } from "svelte/store";

const pad = (n) => String(n).padStart(2, "0");

export const toISO = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const PRESETS = [
  { id: "month", label: "Este mes" },
  { id: "lastMonth", label: "Mes pasado" },
  { id: "7d", label: "Últimos 7 días" },
  { id: "30d", label: "Últimos 30 días" },
  { id: "year", label: "Este año" },
];

export function presetRange(id, today = new Date()) {
  const y = today.getFullYear();
  const m = today.getMonth();
  switch (id) {
    case "lastMonth":
      return { f1: toISO(new Date(y, m - 1, 1)), f2: toISO(new Date(y, m, 0)) };
    case "7d":
      return { f1: toISO(new Date(y, m, today.getDate() - 6)), f2: toISO(today) };
    case "30d":
      return { f1: toISO(new Date(y, m, today.getDate() - 29)), f2: toISO(today) };
    case "year":
      return { f1: toISO(new Date(y, 0, 1)), f2: toISO(today) };
    case "month":
    default:
      return { f1: toISO(new Date(y, m, 1)), f2: toISO(today) };
  }
}

/**
 * Shared by every dashboard in Estadísticas. `seq` bumps on each apply so
 * panels know to reload; it stays 0 until the user applies a range, because
 * the initial (current month) data already comes with the service document.
 */
export const analyticsFilters = writable({
  ...presetRange("month"),
  preset: "month",
  seq: 0,
});

export function applyFilters(range, preset = "custom") {
  analyticsFilters.update((f) => ({
    f1: range.f1,
    f2: range.f2,
    preset,
    seq: f.seq + 1,
  }));
}
